import { Avatar, Box, Paper, Typography } from "@mui/material";
import { statratRed } from "../../../../../config/constants";

const Message = ({ message, fromUser }) => {
    const getAvatar = () => {
        return <Avatar alt={message.name}>{message.avatar}</Avatar>;
    }
    const getMessageBubble = () => {
        return (
            <Paper variant="outlined" sx={{ backgroundColor: fromUser ? statratRed : 'transparent' }}>
                <Typography p={2} minWidth={200}>
                    {message.message}
                </Typography>
            </Paper>
        );
    }
    
    return (
        <>
            {fromUser ? (
                <Box display="flex" gap={2} sx={{ padding: 1.5, paddingLeft: 10 }}>
                    {getMessageBubble()}
                    {getAvatar()}
                </Box>
            ) : (
                <Box display="flex" gap={2} sx={{ padding: 1.5, paddingRight: 10 }}>
                    {getAvatar()}
                    {getMessageBubble()}
                </Box>
            )}
        </>
    )
}

export default Message;
